module.exports = __webpack_public_path__ + "img/ewm.151267b0.png";